module.exports = __webpack_public_path__ + "img/logo.2e5a8535.png";